// 获取京豆账户余额信息
// 在 gifbagSttyle.vue中使用过, 可以参考

import { jingdouAccount } from "@/api/integralCenter/prizeCenter.js";

/**
 * 获取京豆账户余额信息
 * @param {Object} options - 配置选项
 * @param {Boolean} options.venderType - 是否为自营店铺
 * @param {Object} options.formAccount - 账户信息，包含accountType和accountCode
 * @param {Function} options.onSuccess - 成功回调函数，参数为(availableNum, freezeNum)
 * @param {Function} options.onError - 错误回调函数，参数为错误信息
 * @returns {Promise} - 返回请求Promise
 */
export const getJingdouBalance = (options = {}) => {
  const { venderType, formAccount = {}, onSuccess, onError } = options;

  // 判断是否为自营
  const param = venderType ? formAccount : {};

  return jingdouAccount({ ...param })
    .then((res) => {
      if (res && res.code == 1) {
        const availableNum = res.data.availableNum;
        const freezeNum = res.data.freezeNum;

        // 如果提供了成功回调，则调用
        if (typeof onSuccess === 'function') {
          onSuccess(availableNum, freezeNum);
        }

        return {
          availableNum,
          freezeNum,
          success: true
        };
      } else {
        // 如果提供了错误回调，则调用
        if (typeof onError === 'function') {
          onError(res.data.message || '获取京豆余额失败');
        }

        return {
          success: false,
          message: res.data.message
        };
      }
    })
    .catch((error) => {
      // 如果提供了错误回调，则调用
      if (typeof onError === 'function') {
        onError(error.message || '获取京豆余额失败');
      }

      return {
        success: false,
        message: error.message
      };
    });
};